import { render, staticRenderFns } from "./getdown.vue?vue&type=template&id=4cf9d476&scoped=true"
import script from "./getdown.vue?vue&type=script&lang=js"
export * from "./getdown.vue?vue&type=script&lang=js"
import style0 from "./getdown.vue?vue&type=style&index=0&id=4cf9d476&prod&lang=scss&scoped=true"
import style1 from "./getdown.vue?vue&type=style&index=1&id=4cf9d476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf9d476",
  null
  
)

export default component.exports